import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("&nbsp;",{ moduleName: "sh-www/components/lsg/lsg-highlight-circle.hbs" })